import TooManyGroupsError from './too-many-groups-error.component';
export default TooManyGroupsError;
